import { ProductCategory } from 'shared/@generated/models';
import { Link } from 'shared/components/link';
import { Text } from 'shared/components/text';
import { useRoute } from 'shared/library/routes/route';
import { Image } from 'shared/components/image';
import { View } from 'react-native';
import { getProductCategoryImage } from 'shared/library/get-model-image';

export function ShopProductCategoryCard({ category }: { category: ProductCategory }) {
  const route = useRoute();

  return (
    <Link href={route('shop.category', { category: category.slug })} asBlock>
      <View>
        <Image
          src={getProductCategoryImage(category)}
          alt={category.name}
          containerClassName={'aspect-[3/4] w-full'}
          imageClassName={'rounded object-cover group-hover:opacity-75'}
          sizeType={'card'}
          aspectRatio={3 / 4}
        />

        <View
          className={
            'bg-brand-cream absolute bottom-0 left-1/2 my-1.5 -translate-x-1/2 rounded px-2 py-1 md:my-3 md:px-3 md:py-2'
          }
        >
          <Text
            className={'text-brand-brown-dark text-center text-lg font-bold group-hover:underline'}
            numberOfLines={2}
          >
            {category.name}
          </Text>
        </View>
      </View>
    </Link>
  );
}
